import * as React from 'react';
import { connect } from 'react-redux';
import { PERSONAL_INFO, PORTABLE_POSSESSIONS_RISK, CELLPHONE_DETAILS, SALES_ADDRESS } from '../../../routes/routes';
import './CreditHistory.css';
import { ProgressBar, Form, Button } from 'react-bootstrap';
import { validateIdNumber } from '../../../constants/validation';
import { newMobileClientCheck } from '../../../actions/salesActions';
import { navigateTo } from '../../../actions/navigationActions';
import { PRODUCT_BLING } from '../../../constants/constants';
import ReactTooltip from 'react-tooltip';


class CreditHistory extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            idNumber: this.props.profile.idNumber,
            idRegex: true,
            concent: false,
            nextDisabled: true,
            loggedIn: this.props.auth.uid ? true : false,
            isMale: null,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleMaleClick = this.handleMaleClick.bind(this);
        this.handleFemaleClick = this.handleFemaleClick.bind(this);
    }


    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        await this.checkSubmit();
    }

    async handleSwitch(e: any) {
        var checked = e.target.checked;
        await this.setState({ concent: checked });
        await this.checkSubmit();
    }

    async handleBack(e: any) {
        if (this.props.sales.quoteType === PRODUCT_BLING) {
            this.props.redirectTo(SALES_ADDRESS)
        }
        else {
            this.props.redirectTo(PERSONAL_INFO)
        }
    }

    async checkSubmit() {
        const { idNumber } = this.state;
        const { concent } = this.state;

        if (idNumber !== "" && concent) {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }
    }

    async handleMaleClick() {
        await this.setState({ isMale: true });
    }

    async handleFemaleClick() {
        await this.setState({ isMale: false });
    }

    handleClick() {
        const { idNumber } = this.state;
        const { concent } = this.state;
        if (this.props.profile.countryId === 157) {
            if (idNumber.length === 11 && concent && this.state.isMale !== null) {
                this.props.dispatchCreditHistoryCheck(this.state.idNumber, this.state.concent, this.state.isMale);
                if (this.props.sales.quoteType === PRODUCT_BLING) {
                    this.props.redirectTo(CELLPHONE_DETAILS)
                }
            } else {
                if (idNumber.length === 11) {
                    this.setState({ submitted: true, idRegex: true });
                }
                else {
                    this.setState({ submitted: true, idRegex: false });
                }
            }
        }
        else {
            if (validateIdNumber.test(idNumber) && concent) {
                this.props.dispatchCreditHistoryCheck(this.state.idNumber, this.state.concent);
                if (this.props.sales.quoteType === PRODUCT_BLING) {
                    this.props.redirectTo(CELLPHONE_DETAILS)
                }
            } else {
                this.setState({ submitted: true, idRegex: false });
            }
        }
    }

    public render() {

        const { idNumber, submitted } = this.state;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <Button onClick={this.handleBack} className="Back"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></Button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <Button onClick={this.handleBack} className="Back" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></Button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                    <div className="ssp-sales-journey-crown-icon" title=""></div>
                                </div>
                                <div className="mt-21px text-center">
                                    <p className="font-size-16px font-weight-500">Thanks! Now we need the policyholder’s ID number. (This is so<br className="d-none d-lg-block" /> that we can confirm your credit record.)
                                        <img className="raftooltip ml-10px" id="rafTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="creditHistoryTooltip" data-tip="" />
                                        <ReactTooltip id="creditHistoryTooltip" className="rafreacttool" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000} >Your credit record forms part of your risk profile and so we need to use your ID number to get your current score from a credit bureau.</ReactTooltip>
                                    </p>
                                </div>
                                <div className="form-row mb-lg-1 mb-2">
                                    <div className="col-12">
                                        <div className={'form-group' + (submitted && !idNumber ? ' has-error' : '')}>
                                            <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.idNumber !== "" ? "" : " no-opacity")}>ID no.</Form.Label>
                                            <Form.Control type="text" placeholder="ID no." id="CreditCheckInputId" name="idNumber" value={this.state.idNumber} onChange={this.handleChange} maxLength={13} />
                                            {this.props.profile.countryId === 244 &&
                                                <div className="help-block-v2 pt-0px mt-10px">
                                                    {!this.state.idRegex ? <div>ID number must be 13 digits long</div> : null}
                                                </div>
                                            }
                                            {this.props.profile.countryId === 157 &&
                                                <div className="help-block-v2 pt-0px mt-10px">
                                                    {!this.state.idRegex ? <div>ID number must be 11 digits long</div> : null}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {this.props.profile.countryId === 157 &&
                                    <div className="form-row mb-lg-1 mb-2 text-center">
                                        <div className="col-12">
                                            <div className={'form-group' + (submitted && this.state.isMale === null ? ' has-error' : '')}>
                                            <Form.Check name="group1" inline type="radio" label="Male" id="MaleRadio" onChange={this.handleMaleClick} />
                                            <Form.Check name="group1" type="radio" inline label="Female" id="FemaleRadio" onChange={this.handleFemaleClick} />
                                                {submitted && this.state.isMale === null &&
                                                    <div className="help-block">Gender is required</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="form-group pt-4 pb-3">
                                    <div className="row">
                                        <div className="col ItcConcent">
                                            <div className="switch">
                                                <input type="checkbox" id="ItcConcent" name="concent" onChange={this.handleSwitch} />
                                                <label className="switch-normal" htmlFor="ItcConcent">I give my permission to do a credit check</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="help-block-v2 font-size-14px text-center mb-20px">
                                    {submitted && !this.state.idRegex ? <div>We need your permission to do a credit check</div> : null}
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-4 nopa col-xs-12 col-sm-12">
                                        <Button type="submit" className="btn btn-block btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}> Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchCreditHistoryCheck: (idNumber: any, concent: any, isMale: any) => dispatch(newMobileClientCheck(idNumber, concent, isMale))

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreditHistory);